import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { map } from "rxjs/operators";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import {
  BankAccount,
  BankAccountCreate,
  BankAccountLight,
  BankAccountUpdate
} from "src/app/backend/models/bank-account/bank-account";

@Injectable()
export class BankAccountBackend {
  constructor(private http: HttpClient) {}

  load(id: string): Observable<BankAccount> {
    return this.http.get<BankAccount>(
      `${environment.snoots.api.billing}/bank-accounts/${id}`
    );
  }

  loadLight(id: string): Observable<BankAccountLight> {
    return this.http.get<BankAccountLight>(
      `${environment.snoots.api.billing}/bank-accounts/${id}`,
      {
        params: {
          light: true
        }
      }
    );
  }

  list(request: PageRequest): Observable<PaginatedResult<BankAccount>> {
    // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
    return this.http.get<PaginatedResult<BankAccount>>(
      `${environment.snoots.api.billing}/bank-accounts`,
      {
        params: {
          p: request.page,
          s: request.pageSize
        }
      }
    );
  }

  @UserNotify({
    successMessage: marker("Conto corrente creato"),
    errorMessage: marker("Impossibile creare il conto corrente")
  })
  create(request: BankAccountCreate): Observable<BankAccount> {
    return this.http.post<BankAccount>(
      `${environment.snoots.api.billing}/bank-accounts`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Conto corrente aggiornato"),
    errorMessage: marker("Impossibile aggiornare il conto corrente")
  })
  update(id: string, request: Partial<BankAccountUpdate>): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.billing}/bank-accounts/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Conto corrente rimosso"),
    errorMessage: marker("Impossibile rimuovere il conto corrente")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.billing}/bank-accounts/${id}`
    );
  }
}
